import config from '../../config';
import React, { useState, useEffect } from "react";
import axios from "../../api/axiosInstance";
import "./Respondent.css"; // Importing the CSS file
import Select from "react-select";
import * as XLSX from "xlsx";


const SurveyApp = () => {
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [variables, setVariables] = useState([]);
  const [selectedQID, setSelectedQID] = useState([]);
  const [hoveredQuestion, setHoveredQuestion] = useState(null); // State for tooltip
  const [crossTabData, setCrossTabData] = useState(null); // State to hold cross-tabulation data
  const [genderLabels, setGenderLabels] = useState([]);
  const [occupationLabels, setOccupationLabels] = useState([]);
  const [selectedVariables, setSelectedVariables] = useState([]);
  const [selectedRowVariables, setSelectedRowVariables] = useState([]);
  const [selectedColumnVariables, setSelectedColumnVariables] = useState([]);
  const [columnLabels, setColumnLabels] = useState([]);
  const [crosstabData, setCrosstabData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [bannerOptions, setBannerOptions] = useState([]);
  const [selectedBanner, setSelectedBanner] = useState(null);  // State for selected banner
  const [brands, setBrands] = useState([]);
  const [waves, setWaves] = useState([]);
  const [category, setCategory] = useState([]);
  const [statements, setStatements] = useState([]);
  const [crosstabTable, setCrosstabTable] = useState([]); // This will hold the actual matrix data
  const [filtersReady, setFiltersReady] = useState(false);
  const [bannersReady, setBannersReady] = useState(false);
  const [filters, setFilters] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [groupedFilters, setGroupedFilters] = useState({});
  const [hasUserModifiedFilters, setHasUserModifiedFilters] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [expandedSectionDropdowns, setExpandedSectionDropdowns] = useState({});

  
  // Get user data from localStorage
  const user = JSON.parse(localStorage.getItem('userData'));
  const canUpload = user && user.user_level == 'Can upload data';
  
  const toggleSectionDropdown = (sectionName) => {
    setExpandedSectionDropdowns(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };
  const variablesGroupedBySectionDropdown = variables.reduce((acc, item) => {
    let key = item.Section_Dropdown?.trim();

    if (!key) {
      key = selectedSection?.label || "Non Grouped Questions";
    }

    if (key?.toLowerCase() === "section") {
      key =
        item.Section_Name?.trim() ||
        selectedSection?.label ||
        "Non Grouped Questions";
    }

    if (!acc[key]) acc[key] = [];
    acc[key].push(item);

    return acc;
  }, {});


  const lastSectionRef = React.useRef(null);

  useEffect(() => {
    if (!variables || variables.length === 0) return;
    if (!selectedSection?.label) return;

    // ⛔ Do nothing if same section (allow toggle)
    if (lastSectionRef.current === selectedSection.label) return;

    lastSectionRef.current = selectedSection.label;

    // ✅ Auto-open ONLY on section change
    if (variablesGroupedBySectionDropdown[selectedSection.label]) {
      setExpandedSectionDropdowns({
        [selectedSection.label]: true
      });
    } else {
      setExpandedSectionDropdowns({});
    }
  }, [selectedSection, variablesGroupedBySectionDropdown]);


  // console.log(
  //   variables.map(v => ({
  //     Shorter: v.Shorter_Name,
  //     Section_Dropdown: v.Section_Dropdown,
  //     Section_Name: v.Section_Name
  //   }))
  // );




  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/respfilters`); // Make sure your backend domain or proxy is set
        const allFilters = response.data;

        // Step 3: Extract defaults where selected === 1
        // const defaultSelectedFilters = allFilters.filter(f => f.selected === 1);

        setFilters(allFilters);
        // If banner is 12, pre-select all filters
        // if (selectedBanner && selectedBanner !== "Banner 12") {
        //   const defaultSelectedFilters = allFilters.filter(f => f.selected === 1);
        //   setSelectedFilter(defaultSelectedFilters);
        // }
        if (selectedBanner && selectedBanner !== "Banner 12") {
          // Get all filters where selected === 1 (e.g., Year_ID)
          const defaultSelectedFilters = allFilters.filter(f => f.selected === 1);

          // Combine with already selected filters (e.g., Generation)
          const combinedFilters = [...selectedFilter, ...defaultSelectedFilters];

          // Deduplicate by variable_name + value
          const uniqueMap = new Map();
          combinedFilters.forEach(f => {
            const key = `${f.variable_name}-${f.value}`;
            if (!uniqueMap.has(key)) {
              uniqueMap.set(key, f);
            }
          });

          // Set the cleaned, combined selected filters
          setSelectedFilter(Array.from(uniqueMap.values()));
        }
        setFiltersReady(true); // ✅ mark as ready
      } catch (error) {
        console.error("Failed to load filters:", error);
      }
    };
    if (selectedBanner) {
      fetchFilters();
    }
  }, [selectedBanner]);

  const getGroupedFilters = (filters) => {
    const grouped = {};
    filters.forEach(({ variable_name, value }) => {
      if (!grouped[variable_name]) grouped[variable_name] = [];
      grouped[variable_name].push(value);
    });
    return grouped;
  };


  useEffect(() => {
    if (
      filtersReady &&
      bannersReady &&
      selectedFilter.length > 0 &&
      selectedBanner &&
      selectedBanner !== "Banner 12" &&
      selectedVariables.length > 0 &&
      !hasUserModifiedFilters // ✅ only run if user hasn't manually changed filters
    ) {
      const grouped = {};

      selectedFilter.forEach(({ variable_name, value }) => {
        if (!grouped[variable_name]) grouped[variable_name] = [];
        grouped[variable_name].push(value);
      });

      setGroupedFilters(grouped);
      fetchCrosstabData(selectedBanner, grouped);
    }
  }, [filtersReady, bannersReady, selectedBanner, selectedVariables]);

  const handleApplyFilters = (banner) => {
    const yearFilters = filters.filter(f => f.variable_name === "Year_ID")
    const otherSelectedFilters = selectedFilter.filter(f => f.variable_name !== "Year_ID");
    const combinedFilters = [...yearFilters, ...otherSelectedFilters];
    const uniqueMap = new Map();
    combinedFilters.forEach(f => {
      const key = `${f.variable_name}-${f.value}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, f);
      }
    });
    const filtersToUse = banner === "Banner 12" ? Array.from(uniqueMap.values()) : selectedFilter;
    const grouped = getGroupedFilters(filtersToUse); // ✅ always group the correct filters
    setGroupedFilters(grouped); // optional for UI
    fetchCrosstabData(banner, grouped);
  };


  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/sections`)
      .then((response) => setSections(response.data))
      .catch((error) => console.error("Error fetching sections:", error));
  }, []);

  // Fetch variables when a section is selected
  const handleSectionChange = (selectedOption) => {
    const section = selectedOption?.value; // Get the value from the selected option
    setSelectedSection(selectedOption); // Store the entire object as per react-select
    setLoading(true);
    setDataFetched(false);
    setSelectedVariables([]);
    axios
      .get(`${config.API_BASE_URL}/variables/${section}`)
      .then((response) => {
        setVariables(response.data);
        // console.log("Variables fetched for section:", response.data); // Debugging
      })
      .catch((error) => console.error("Error fetching variables:", error));
    setLoading(false);
    setDataFetched(true);
  };

  useEffect(() => {
    if (sections.length > 0 && !selectedSection) {
      // Automatically select the first section
      const firstSection = { value: sections[0], label: sections[0] };
      setSelectedSection(firstSection);

      // Fetch variables for the first section automatically
      axios
        .get(`${config.API_BASE_URL}/variables/${firstSection.value}`)
        .then((response) => {
          setVariables(response.data);
          // console.log("Variables fetched for section:", response.data);
        })
        .catch((error) => console.error("Error fetching variables:", error));
    }
  }, [sections, selectedSection]);

  useEffect(() => {
    if (variables.length > 0) {
      const firstVar = variables[0];

      setSelectedVariables([{
        qid: firstVar.QID_for_Multi,
        variableName: firstVar.Variable_names,
        shorter_name: firstVar.Shorter_Name,
        type_of_question: firstVar.Type_of_question,
        Question_text: firstVar.Question_text,
        weight: firstVar.weight,
        Inc_Excl: firstVar.Inc_Excl,
      }]);
    }
  }, [variables]);

  // Auto-select first banner if not already selected
  useEffect(() => {
    axios.get(`${config.API_BASE_URL}/banners`)
      .then((response) => {
        const banners = response.data.map((banner) => ({
          value: banner.value,
          label: banner.label,
        }));
        setBannerOptions(banners);

        // Set default selected banner
        const defaultBanner = response.data.find(b => b.selected === 1);
        if (defaultBanner) {
          setSelectedBanner(defaultBanner.value);
          setBannersReady(true);
        }
      })
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);
  const toggleQIDSelection = (qid, variableName, shorter_name, type_of_question, question_text, weight, Inc_Excl) => {
    setSelectedVariables([{ qid, variableName, shorter_name, type_of_question, Question_text: question_text, weight, Inc_Excl }]);
  };


  const isSelected = (qid) => {
    return selectedVariables.some((item) => item.qid === qid);
  };

  const buildPayload = (banner, selectedFilters) => {
    const selectedQIDs = selectedVariables.map((item) => item.qid);
    const selectedShorterNames = selectedVariables.map((item) => item.shorter_name);
    const selectedTypesOfQuestion = selectedVariables.map((item) => item.type_of_question);
    const selectedvariableNames = selectedVariables.map((item) => item.variableName).flat();
    const selectedWeight = selectedVariables.map((item) => item.weight);
    const selectedInc_Excl = selectedVariables.map((item) => item.Inc_Excl);

    return {
      banner: banner,
      qids: selectedQIDs,
      shorter_names: selectedShorterNames,
      type_of_question: selectedTypesOfQuestion,
      variableName: selectedvariableNames,
      selectedFilter: selectedFilters,
      weight: selectedWeight,
      Inc_Excl: selectedInc_Excl,
    };
  };

  // Function to fetch crosstab data based on banner clicked
  const fetchCrosstabData = async (banner, selectedFilters) => {
    setBrands([]);
    setWaves([]);
    setCrosstabTable([]);
    setStatements([]);
    setCategory([]);
    setLoading(true);
    setDataFetched(false);
    setError(null); // Reset error befoe fetching new data

    try {
      // Collect all the QIDs from the selected variables
      const payload = buildPayload(banner, selectedFilters);
      // Prevent fetching if payload is invalid
      if (payload.qids.length === 0 || payload.variableName.length === 0) {
        console.warn("Invalid payload, skipping API call.");
        setLoading(false);
        return;
      }
      const response = await fetch(`${config.API_BASE_URL}/api/get_crosstab_data_traditional`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch crosstab data');
      }
      const data = await response.json();
      const { Brands, Waves, Data, Statements, Category } = data;

      setBrands(Brands);
      setWaves(Waves);
      setCrosstabTable(Data);
      setStatements(Statements);
      setCategory(Category)
      // console.log("Fetched Data:", data);
    } catch (error) {
      console.error('Error fetching crosstab data:', error);
      setError(error.message);
    } finally {
      setLoading(false);
      setDataFetched(true);
      if (banner === "Banner 12") {
        // Get all filters where selected === 1 (e.g., Year_ID)
        const defaultSelectedFilters = filters.filter(f => f.selected === 1);

        // Combine with already selected filters (e.g., Generation)
        const combinedFilters = [...selectedFilter, ...defaultSelectedFilters];

        // Deduplicate by variable_name + value
        const uniqueMap = new Map();
        combinedFilters.forEach(f => {
          const key = `${f.variable_name}-${f.value}`;
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, f);
          }
        });

        // Set the cleaned, combined selected filters
        setSelectedFilter(Array.from(uniqueMap.values()));
      }
    }
  };

  useEffect(() => {
    if (
      selectedVariables.length > 0 &&
      selectedBanner &&
      selectedFilter.length > 0
    ) {
      const yearFilters = filters.filter(f => f.variable_name === "Year_ID")
      const otherSelectedFilters = selectedFilter.filter(f => f.variable_name !== "Year_ID");
      const combinedFilters = [...yearFilters, ...otherSelectedFilters];
      const uniqueMap = new Map();
      combinedFilters.forEach(f => {
        const key = `${f.variable_name}-${f.value}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, f);
        }
      });
      const filtersToUse = selectedBanner === "Banner 12" ? Array.from(uniqueMap.values()) : selectedFilter;

      const grouped = getGroupedFilters(filtersToUse);
      fetchCrosstabData(selectedBanner, grouped);
    }
  }, [selectedVariables]);

  useEffect(() => {
    if (
      selectedBanner === "Banner 12" &&
      selectedVariables.length > 0 &&
      filtersReady &&
      bannersReady
    ) {
      const yearFilters = filters.filter(f => f.variable_name === "Year_ID")
      const otherSelectedFilters = selectedFilter.filter(f => f.variable_name !== "Year_ID");
      const combinedFilters = [...yearFilters, ...otherSelectedFilters];
      const uniqueMap = new Map();
      combinedFilters.forEach(f => {
        const key = `${f.variable_name}-${f.value}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, f);
        }
      });
      const filtersToUse = selectedBanner === "Banner 12" ? Array.from(uniqueMap.values()) : selectedFilter;
      const grouped = getGroupedFilters(filtersToUse); // use all filters for Banner 12
      fetchCrosstabData("Banner 12", grouped);
    }
  }, [selectedBanner, selectedVariables, filtersReady, bannersReady]);



  const handleBannerChange = (selectedOption) => {
    const selected = selectedOption.value;
    const yearFilters = filters.filter(f => f.variable_name === "Year_ID")
    const otherSelectedFilters = selectedFilter.filter(f => f.variable_name !== "Year_ID");
    const combinedFilters = [...yearFilters, ...otherSelectedFilters];
    const uniqueMap = new Map();
    combinedFilters.forEach(f => {
      const key = `${f.variable_name}-${f.value}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, f);
      }
    });
    const filtersToUse = selected === "Banner 12" ? Array.from(uniqueMap.values()) : selectedFilter;
    const grouped = getGroupedFilters(filtersToUse);

    setSelectedBanner(selected);
    setLoading(true);      // Add this
    setDataFetched(false); // And this
    fetchCrosstabData(selected, grouped);
  };


  const handleDownload = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/download-excel`, {
        responseType: 'blob',  // Important for downloading files
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'data.xlsx'); // Set the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  };

  const sortedBrands = [...brands]
    .filter(
      (brand) =>
        brand.Visible !== 0 &&
        brand.Name !== "BASE: ALL RESPONDENTS(Weighted)" // Exclude Weighted base
    )
    .sort((a, b) => {
      if (a.Name === "BASE: ALL RESPONDENTS(Un-Weighted)") return -1;
      if (b.Name === "BASE: ALL RESPONDENTS(Un-Weighted)") return 1;
      return 0;
    });

  const download = async (banner) => {
    const yearFilters = filters.filter(f => f.variable_name === "Year_ID")
    const otherSelectedFilters = selectedFilter.filter(f => f.variable_name !== "Year_ID");
    const combinedFilters = [...yearFilters, ...otherSelectedFilters];
    const uniqueMap = new Map();
    combinedFilters.forEach(f => {
      const key = `${f.variable_name}-${f.value}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, f);
      }
    });
    const filtersToUse = banner === "Banner 12" ? Array.from(uniqueMap.values()) : selectedFilter;
    const grouped = getGroupedFilters(filtersToUse);
    // const grouped = selectedBanner === "Banner 12" ? {} : getGroupedFilters(selectedFilter);
    const payload = buildPayload(banner, grouped);
    payload.Kpi = payload.Kpi = selectedVariables?.[0]?.qid || "UnknownKPI";;  // Or dynamic if needed
    payload.question_text = selectedVariables?.[0]?.Question_text || null;   // <-- add this

    // Format timestamp: Jun-08-2025_21:51:13
    const now = new Date();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = String(now.getDate()).padStart(2, '0');
    const month = months[now.getMonth()];
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${month}-${day}-${year} ${hours}.${minutes}.${seconds}`;

    const filename = `${payload.Kpi}- ${timestamp}.xlsx`;
    try {
      const response = await axios.post(`${config.API_BASE_URL}/api/download`, payload, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // const uniqueStatements = Array.from(
  //   new Map(statements.map(item => [item.Id, item])).values()
  // ).sort((a, b) => b.Id - a.Id);  // Descending order by Id

  const uniqueStatements = Array.from(
    new Map(statements.map(item => [item.Id, item])).values()
  ).sort((a, b) => {
    if (a.Name === "Total") return -1;  // Total always first
    if (b.Name === "Total") return 1;
    return b.Id - a.Id;  // Descending order by Id for others
  });


  // Assume all waves belong to the first unique statement
  const firstStatementId = uniqueStatements[0]?.Id;

  const hasValidData = () => {
    return (
      Array.isArray(brands) &&
      brands.length > 0 &&
      Array.isArray(waves) &&
      waves.length > 0 &&
      Array.isArray(crosstabTable) &&
      crosstabTable.length > 0 &&
      Array.isArray(statements) &&
      statements.length > 0
    );
  };

  const selectedVar = variables.find(
    v => String(v.QID_for_Multi).trim() === String(selectedVariables?.[0]?.qid).trim()
  );

  const hideMean =
    (selectedVar?.Mean || "")
      .toString()
      .trim()
      .toLowerCase() === "hide";

  const filteredBrands = sortedBrands.filter(
    (brand) =>
      !(hideMean && brand?.Name?.toString().trim().toLowerCase() === "mean")
  );
  return (
    <div className="survey-container">
      {/* Section Dropdown */}
      <div className="header-section">
        <label>Select Section:</label>
        <div style={{ width: '50%' }}>
          <Select
            value={selectedSection}
            onChange={handleSectionChange}
            options={sections.map((section) => ({
              label: section,
              value: section,
            }))}
            placeholder="-- Select Section --"
          />
        </div>
        <label>Select Banner:</label>
        <div style={{ width: '25%' }}>
          <Select
            value={bannerOptions.find((opt) => opt.value === selectedBanner) || null}
            onChange={(selectedOption) => {
              if (!selectedSection) {
                alert("Please select a section first!");
                return;
              }
              setSelectedBanner(selectedOption.value);
              handleBannerChange(selectedOption);
            }}
            options={bannerOptions}
            placeholder="-- Select Banner --"
          />
        </div>
      </div>

      <div style={{ display: 'flex' }}>

        {/* Variables List */}
        {variables.length > 0 && (
          <div className="variable-list">
            <div style={{ marginBottom: '10px' }}>
              <>
                {/* Year filter - only show when not Banner 12 and exclude Generation options */}
                {selectedBanner !== "Banner 12" && selectedBanner !== "Banner 13" && (
                  <>
                    <label>Filter by Year: </label>
                    <Select
                      options={filters.filter(f => f.variable_name !== "Generation")}
                      value={selectedFilter.filter(f => f.variable_name !== "Generation")}
                      onChange={(selected) => {
                        if (selectedBanner !== "Banner 12" && selectedBanner !== "Banner 13") {
                          // Only update non-Generation filters
                          const newFilters = selected || [];
                          const generationFilters = selectedFilter.filter(f => f.variable_name === "Generation");
                          setSelectedFilter([...newFilters, ...generationFilters]);
                          setHasUserModifiedFilters(true);
                        }
                      }}
                      placeholder="Select Year"
                      isMulti
                      getOptionLabel={(option) => option.Label}
                      getOptionValue={(option) => `${option.variable_name}-${option.value}`}
                    />
                    <br />
                  </>
                )}

                {/* Generation filter is always shown */}
                {/* <label>Generation: </label>
                <Select
                  isMulti
                  value={selectedFilter.filter(f => f.variable_name === "Generation")}
                  options={filters
                    .filter(f => f.variable_name === "Generation")
                    .map(f => ({ value: f.value, label: f.Label }))
                  }
                  onChange={(selectedOptions) => {
                    const generationSelections = (selectedOptions || []).map(opt => ({
                      variable_name: "Generation",
                      value: opt.value,
                      label: opt.label, // Optional: if you want to access/display label later
                    }));

                    // Replace only Generation filters with selected ones (do not preserve old ones)
                    setSelectedFilter(prev => [
                      ...prev.filter(f => f.variable_name !== "Generation"),
                      ...generationSelections,
                    ]);

                    setHasUserModifiedFilters(true);
                  }}
                /> */}
                <br />
                {/* Immigration Status Filter (Born_status) — Always visible after Generation */}
                {/* <label>Immigration Status: </label>
                <Select
                  isMulti
                  value={selectedFilter.filter(f => f.variable_name === "Born_status")}
                  options={filters
                    .filter(f => f.variable_name === "Born_status") // fetch Immigration status
                    .map(f => ({ value: f.value, label: f.Label }))
                  }
                  onChange={(selectedOptions) => {
                    const immigrationSelections = (selectedOptions || []).map(opt => ({
                      variable_name: "Born_status",
                      value: opt.value,
                      label: opt.label,
                    }));

                    setSelectedFilter(prev => [
                      ...prev.filter(f => f.variable_name !== "Born_status"),
                      ...immigrationSelections,
                    ]);

                    setHasUserModifiedFilters(true);
                  }}
                /> */}

                {/* Apply button */}

                {selectedBanner !== "Banner 12" && selectedBanner !== "Banner 13" && (
                  <>
                    <button
                      onClick={() => handleApplyFilters(selectedBanner)}
                      className="download-button"
                    >
                      Apply Filters
                    </button>
                  </>
                )}

                {/* Banner 12 warning */}
                {selectedBanner === "Banner 12" && (
                  <div style={{ fontStyle: 'italic', color: 'gray', marginTop: '10px' }}>
                    Year filter is not applicable for Banner 'Year'.
                  </div>
                )}
                {/* Banner 13 warning */}
                {selectedBanner === "Banner 13" && (
                  <div style={{ fontStyle: 'italic', color: 'gray', marginTop: '10px' }}>
                    Year filter is not applicable for Banner 'Current Year'.
                  </div>
                )}
              </>


              <button onClick={() => download(selectedBanner)} className="download-button">
                <i className="fa fa-download"></i>
                ExcelFile
              </button>

              {canUpload && (
                <button onClick={handleDownload} className="download-button">
                  Download Survey Question
                </button>
              )}
            </div>
            <h3>Variables</h3>

            {Object.entries(variablesGroupedBySectionDropdown).map(
              ([sectionDropdownName, items]) => (
                <div key={sectionDropdownName} className="section-dropdown-block">
                  <div
                    className="section-dropdown-header"
                    onClick={() => toggleSectionDropdown(sectionDropdownName)}
                  >
                    <div>
                      <strong>{sectionDropdownName}</strong>
                      <span style={{ float: "right" }}>
                        {expandedSectionDropdowns[sectionDropdownName] ? "▲" : "▼"}
                      </span>
                    </div>
                  </div>

                  {expandedSectionDropdowns[sectionDropdownName] && (
                    <ul className="section-dropdown-list">
                      {items.map((item, index) => (
                        <li
                          key={`${item.QID_for_Multi}-${index}`}
                          className={`hover-item ${isSelected(item.QID_for_Multi) ? "selected" : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleQIDSelection(
                              item.QID_for_Multi,
                              item.Variable_names,
                              item.Shorter_Name,
                              item.Type_of_question,
                              item.Question_text,
                              item.weight,
                              item.Inc_Excl
                            );
                          }}
                        >
                          <div>
                            <strong>{item.Shorter_Name}</strong>
                            {/* <span
                              dangerouslySetInnerHTML={{ __html: item.Shorter_Name }}
                            /> */}
                          </div>
                          <div>{item.QID_for_Multi}</div>

                          {hoveredQuestion === index && (
                            <div className="tooltip">{item.Question_text}</div>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )
            )}
          </div>
        )}

        {/* Display Cross Tabulation Data */}
        {loading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : hasValidData() ? (
          <div className="cross-tab-container">
            {selectedVariables.length > 0 && selectedVariables[0].Question_text && (
              <h4>{selectedVariables?.[0]?.qid}:  {selectedVariables[0].Question_text}</h4>
            )}
            <div className="tablesview">
              <table className="data-table">
                <thead>
                  {selectedBanner === "Banner 12" ? (
                    <>
                      <tr>
                        <th></th>
                        {/* Wave names on first row */}
                        {waves.map((wave) => (
                          <th key={wave.Index} colSpan={uniqueStatements.length}>
                            {wave.Name || "-"}
                          </th>
                        ))}
                      </tr>
                      <tr>
                        <th></th>
                        {/* Statement names on second row */}
                        {uniqueStatements.map((statement) => (
                          <th key={statement.Index}>{statement.Name || "-"}</th>
                        ))}
                      </tr>
                    </>
                  ) : (
                    <>
                      <tr>
                        <th></th>
                        {uniqueStatements.map((statement) => {
                          return (
                            <th key={statement?.Index} colSpan={waves.length}>
                              {statement?.Name ?? "-"}
                            </th>
                          );
                        })}
                      </tr>
                      <tr>
                        <th></th>
                        {/* Then waves */}
                        {uniqueStatements.map((statement) =>
                          waves.map((wave) => (
                            <th key={`${statement.Index}-${wave.Index}`}>{wave?.Name ?? "-"}</th>
                          ))
                        )}
                      </tr>
                    </>
                  )}
                </thead>
                <tbody>
                  {category.length > 0 ? (
                    category.map((cat, cidx) => (
                      <React.Fragment key={`category-${cidx}`}>
                        {/* Category Header Row */}
                        {/* <tr className="category-row">
                          <td colSpan={1 + uniqueStatements.length * waves.length} style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                            {cat.Name}
                          </td>
                        </tr> */}
                        {/* Category Header Row */}
                        {!(
                          category.length === 1 &&
                          cat.Name === "Excluding Zero"
                        ) && (
                            <tr className="category-row">
                              <td
                                colSpan={1 + uniqueStatements.length * waves.length}
                                style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}
                              >
                                {cat.Name}
                              </td>
                            </tr>
                          )}

                        {/* Brands under category */}
                        {filteredBrands.map((brand) => {
                          // agar brand BASE hai aur cidx === 1 hai to row bilkul render hi mat karo
                          if (
                            brand?.Name === "BASE: ALL RESPONDENTS(Un-Weighted)" &&
                            cat.Index === 1   // 🔥 Excluding Zero
                          ) {
                            return null;
                          }


                          return (
                            <tr
                              key={`brand-${brand?.Index}-${cidx}`}
                              className={brand?.Name === "BASE: ALL RESPONDENTS(Un-Weighted)" ? "bold-row" : ""}
                            >
                              <td>
                                {brand?.Name}
                              </td>

                              {uniqueStatements.map((statement) =>
                                waves.map((wave) => {
                                  const cell = crosstabTable.find(
                                    (entry) =>
                                      entry?.bindex === brand?.Index &&
                                      entry?.windex === wave?.Index &&
                                      entry?.sindex === statement?.Index &&
                                      // entry?.cindex === cidx
                                      entry?.cindex === cat.Index
                                  );

                                  return (
                                    <td key={`${brand?.Index}-${statement?.Index}-${wave?.Index}`}>
                                      {brand?.Name === "BASE: ALL RESPONDENTS(Un-Weighted)" ? (
                                        <div>{cell?.Base ?? "-"}</div>
                                      ) : (
                                        cell ? (
                                          <div>

                                            {/* <strong>{brand.Name === "Mean" ? cell.Freq.toFixed(1) : cell.Base}</strong>
                                          <br /> */}
                                            {brand.Name === "Mean" ? "" : (
                                              <span>{cell.Freq === 0 ? "-" : cell.Freq?.toFixed(2)}</span>
                                            )}
                                          </div>
                                        ) : "-"
                                      )}
                                    </td>
                                  );
                                })
                              )}
                            </tr>
                          );
                        })}

                      </React.Fragment>
                    ))
                  ) : (
                    // No categories present
                    filteredBrands.map((brand) => (
                      <tr
                        key={`brand-${brand?.Index}`}
                        className={brand?.Name === "BASE: ALL RESPONDENTS(Un-Weighted)" ? "bold-row" : ""}
                      >
                        <td>{brand?.Name}</td>
                        {uniqueStatements.map((statement) =>
                          waves.map((wave) => {
                            const cell = crosstabTable.find(
                              (entry) =>
                                entry?.bindex === brand?.Index &&
                                entry?.windex === wave?.Index &&
                                entry?.sindex === statement?.Index
                            );
                            return (
                              <td key={`${brand?.Index}-${statement?.Index}-${wave?.Index}`}>
                                {brand?.Name === "BASE: ALL RESPONDENTS(Un-Weighted)" ? (
                                  <div>{cell?.Base ?? "-"}</div>
                                ) : (
                                  cell ? (
                                    <div>
                                      {/* this is for testing link */}
                                      {/* <strong>{brand.Name === "Mean" ? cell.Freq.toFixed(1) : cell.Freq.toFixed(2)}</strong>
                                      <br /> */}
                                      {/* this is for live link */}
                                      <strong>{brand.Name === "Mean" ? cell.Freq.toFixed(1) : ''}</strong>
                                      {/* <br /> */}
                                      {brand.Name === "Mean" ? "" : (<span>{cell.Perc === 0 ? "-" : `${cell.Perc?.toFixed(0)}%`}</span>)}

                                    </div>
                                  ) : "-"
                                )}
                              </td>
                            );
                          })
                        )}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : dataFetched ? (
          <div className="nodata-message"><i><b>No data available to display for selected filter.</b></i></div>
        ) : null}
      </div>
    </div>
  );
};

export default SurveyApp;



